import React, { useState } from "react";
import get from "lodash/get";
import { ResponsiveImage } from "@quintype/components";
import { useSwipeable } from "react-swipeable";
import { LeftArrowIcon } from "../../../../../assets/icons/LeftArrowIcon";
import { RightArrowIcon } from "../../../../../assets/icons/RightArrowIcon";
import "./co-branded-slider.m.css";

export const CoBrandedSlider = ({ stories }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  if (!stories || stories.length === 0) {
    return null;
  }
  const totalStories = stories.length;
  const currentStory = stories[currentIndex];
  const handlePrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? totalStories - 1 : prev - 1));
  };
  const handleNext = () => {
    setCurrentIndex((prev) => (prev === totalStories - 1 ? 0 : prev + 1));
  };
  const swipeHandlers = useSwipeable({
    onSwipedLeft: handleNext,
    onSwipedRight: handlePrevious,
    preventScrollOnSwipe: true,
    trackTouch: true,
    trackMouse: false,
  });
  const {
    headline: storyHeadline,
    subheadline,
    ["hero-image-s3-key"]: heroImageS3Key,
    ["hero-image-metadata"]: heroImageMetadata = {},
    metadata,
    slug,
  } = currentStory;

  const headline =
    get(currentStory, ["alternative", "home", "default", "headline"], storyHeadline) ||
    storyHeadline;

  const sponsoredBy = metadata?.["sponsored-by"];
  const storyUrl = `/${slug}`;

  return (
    <div styleName="slider-container" {...swipeHandlers}>
      <div styleName="slider-image">
        <a href={storyUrl}>
          <ResponsiveImage
            slug={heroImageS3Key}
            metadata={heroImageMetadata}
            aspectRatio={[16, 9]}
            defaultWidth={450}
            widths={[450]}
            imgParams={{ auto: ["format", "compress"] }}
            alt={headline || ""}
          />
        </a>
      </div>

      <div styleName="slider-content">
        <div styleName="slider-header">
          <p styleName="slider-label">{sponsoredBy || ""}</p>

          <div styleName="slider-navigation">
            <button onClick={handlePrevious} aria-label="Previous story">
              <LeftArrowIcon />
            </button>

            <span>
              {currentIndex + 1}/{totalStories}
            </span>

            <button onClick={handleNext} aria-label="Next story">
              <RightArrowIcon />
            </button>
          </div>
        </div>

        <div styleName="slider-text-content">
          <a href={storyUrl}>
            <h3 styleName="slider-headline">{headline}</h3>
            <p styleName="slider-subheadline">{subheadline}</p>
          </a>
        </div>

      </div>
    </div>
  );
};
